import { Link } from 'components/core-v2/atoms'

import { COPY } from './constants'
import classes from './index.module.scss'

export const ContactUs = () => (
  <p className={classes.contactUs}>
    {COPY.contactUs} <Link to={`mailto:${COPY.email}`}>{COPY.email}</Link>
  </p>
)
